import { render, staticRenderFns } from "./CommonLink.vue?vue&type=template&id=57016d4c"
import script from "./CommonLink.vue?vue&type=script&lang=js"
export * from "./CommonLink.vue?vue&type=script&lang=js"
import style0 from "./CommonLink.vue?vue&type=style&index=0&id=57016d4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports